
import { Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

interface PremiumContentOverlayProps {
  show?: boolean;
}

/**
 * Overlay displayed over the article content prompting users to subscribe.
 */
const PremiumContentOverlay = ({ show = true }: PremiumContentOverlayProps) => {
  if (!show) return null;

  return (
    <div className="absolute inset-0 bg-white/80 flex items-center justify-center p-4 z-20">
      <div className="text-center space-y-4">
        <p className="text-lg font-medium flex items-center justify-center gap-2">
          <Lock className="w-4 h-4" />
          This content is for subscribers
        </p>
        <Link to="/pricing">
          <Button>Subscribe to read more</Button>
        </Link>
      </div>
    </div>
  );
};

export default PremiumContentOverlay;
